import { Paper, Tab, Tabs } from "@material-ui/core";
import React from "react";
import { CreateExercise } from "./CreateExercise";
import { ViewExercise } from "./ViewExercise";
import { NavLink, Route, Switch, useLocation } from "react-router-dom";
import { Area } from "types";
import { EditExercise } from "./EditExercise";
import { Exercises, LessonPreviewParent, Lessons, Template, Templates } from "./views";
import { LessonEditor } from "./views/lessons";

export const CreateContent: React.VFC = () => {
  //const area = "/" + String(useRouteMatch<{ area: string }>(`${Area.CreateContent}/:area`)?.params.area);
  const path = useLocation().pathname.split("/").slice(0, 3).join("/");

  return (
    <Paper style={{ padding: "16px", margin: "16px auto", backgroundColor: "#fff", maxWidth: "1200px" }}>
      <Tabs value={path} style={{ marginBottom: 32 }}>
        <Tab
          label="New Exercise"
          component={NavLink}
          to={Area.CreateContent_NewExercise}
          value={Area.CreateContent_NewExercise}
        />
        <Tab
          label="Edit Exercise"
          component={NavLink}
          to={`${Area.CreateContent_EditExercise}`}
          value={Area.CreateContent_EditExercise}
        />
        <Tab
          label="Exercises"
          component={NavLink}
          to={Area.CreateContent_Exercises}
          value={Area.CreateContent_Exercises}
        />
        <Tab label="Lessons" component={NavLink} to={Area.CreateContent_Lessons} value={Area.CreateContent_Lessons} />
        <Tab
          label="Templates"
          component={NavLink}
          to={Area.CreateContent_Templates}
          value={Area.CreateContent_Templates}
          disabled
        />
      </Tabs>
      <Switch>
        <Route path={Area.CreateContent_NewExercise}>
          <CreateExercise />
        </Route>
        <Route path={`${Area.CreateContent_EditExercise}`} exact>
          <EditExercise />
        </Route>
        <Route path={`${Area.CreateContent_EditExercise}/:id`}>
          <EditExercise />
        </Route>
        <Route path={`${Area.CreateContent_Exercises}/new`}>
          <CreateExercise />
        </Route>
        <Route path={`${Area.CreateContent_Exercises}/:id/edit`}>
          <EditExercise />
        </Route>
        <Route path={`${Area.CreateContent_Exercises}/:id`}>
          <ViewExercise />
        </Route>
        <Route path={Area.CreateContent_Exercises}>
          <Exercises />
        </Route>
        <Route path={`${Area.CreateContent_Lessons}/new`}>
          <LessonEditor />
        </Route>
        <Route path={`${Area.CreateContent_Lessons}/:id/edit`}>
          <div>Edit one lesson</div>
        </Route>
        <Route path={`${Area.CreateContent_Lessons}/:id`}>
          <LessonPreviewParent />
        </Route>
        <Route path={Area.CreateContent_Lessons}>
          <Lessons />
        </Route>
        <Route path={`${Area.CreateContent_Templates}/:id/edit`}>
          <div>Edit one template</div>
        </Route>
        <Route path={`${Area.CreateContent_Templates}/:id`}>
          <Template />
        </Route>
        <Route path={Area.CreateContent_Templates}>
          <Templates />
        </Route>
      </Switch>
    </Paper>
  );
};
